 document.addEventListener("DOMContentLoaded", function() {
  var detailBtns = document.querySelectorAll(".esim_details");
  var close_popups = document.querySelectorAll(".close_popup");
   var overlays = document.querySelectorAll(".popup_overlay");
   var simUrls = document.querySelectorAll(".installbtn");
   
  

  detailBtns.forEach((singleBtn) => {
   
    singleBtn.addEventListener("click", function() {
      var qrcodeDisplay = singleBtn.closest(".flag_tile").querySelector(".qrcode_img");
      console.log("Image",qrcodeDisplay);
      qrcodeDisplay.style.display = "block";
      
      document.querySelector(".customloader_overlay").classList.remove("hidden");
       var orderId = this.getAttribute("data-id");
       var orderCCid = this.getAttribute("data-ccid");
     var apiUrl = `https://phpstack-1216846-4323606.cloudwaysapps.com/api/balance-detail?order_no=${orderId}&iccid=${orderCCid}`;
       var detailBtnOrder = this.getAttribute("data-order");
    var popup =  document.querySelector(".main-popup[data-order='"+ detailBtnOrder  +"']");
      fetch(apiUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        else{
           document.querySelector(".customloader_overlay").classList.add("hidden");
          popup.style.display = "block";
        }
        return response.json();
      })
      .then(data => {
        // Handle the API response data
        console.log('API Response:', data);
        var totalVolume =  data.esimList[0].totalVolume;
        data.esimList.forEach(function(esim){
          console.log("Total Volume",esim.totalVolume);
          var totalVolume = (esim.totalVolume / 1073741824 );
          var orderUsage = ( esim.orderUsage / 1073741824 );
          var usedDataMB = ( esim.orderUsage / 1048576);
          var usedMBDec = usedDataMB.toFixed(2);
          var remaningData = totalVolume - orderUsage;
          var remainingDataDec = remaningData.toFixed(2);
           var percentage = ((totalVolume - orderUsage) / totalVolume) * 100
            // console.log("percenvalue", percentage + "%");
          // console.log("Remaining Data", remaningData);
          var totalText = popup.querySelector(".totalMB");
          var usedText = popup.querySelector(".usedMB");
          var remainingText = popup.querySelector(".remaining_data_value");
          var remainingBar = popup.querySelector(".progressdata");
          var mainBar = popup.querySelector(".progress-wrapper");
          // console.log(totalText);
          totalText.textContent = totalVolume + " " + "GB";
          usedText.textContent = usedMBDec + " " + "MB";
          remainingText.textContent = remainingDataDec + " " + "GB";
          remainingBar.style.width = percentage + "%";
          // afterStyle.style.width = percentage + "%";
          mainBar.style.setProperty('--width', percentage + '%');
          
        });
        // console.log('API', data.esimList[0].totalVolume);
        // Add your logic to handle the data here
        
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        // Add your error handling logic here
      });
    });
    
  });
   
   simUrls.forEach((singleURl)=>{
     singleURl.addEventListener("click",function(){
     var urlIframe = this.closest(".sim_btns").querySelector(".iframe_container");
      var closeFrame = urlIframe.querySelector(".close_iframe");
            closeFrame.addEventListener("click", function() {
              this.closest(".iframe_container").classList.add("hidden");
            });
       urlIframe.classList.remove("hidden");
     urlIframe.addEventListener("click",function(){
         console.log("Iframe COntainer clicked");
          if (urlIframe.classList.includes("hidden")) {
          }else{
            urlIframe.classList.add("hidden");
            urlIframe.style.display = "none";
          }
       });
     });

   });

   // var iframeContainers = document.querySelectorAll(".iframe_container");
   // iframeContainers.forEach((singleFrame)=>{
   //    singleFrame.addEventListener("click", function() {
   //      console.log("Iframe COntainer clicked;");
   //        // if (!singleFrame.classList.contains("hidden")) {
   //          singleFrame.classList.add("hidden");
   //      singleFrame.style.display = "none";
   //        // }
   //      });
     
   // })
  

   
    close_popups.forEach((close_popup) => {
    close_popup.addEventListener("click", function() {
      this.closest(".main-popup").style.display = "none";
      var qrCodes = document.querySelectorAll(".qrcode_img");
      qrCodes.forEach(function(qrCode) {
          if (qrCode.style.display === 'block') {
              qrCode.style.display = 'none';
          }
        });
    });
    });
    overlays.forEach((overlay) => {
    overlay.addEventListener("click", function() {
      this.closest(".main-popup").style.display = "none";
      var qrCodes = document.querySelectorAll(".qrcode_img");
      qrCodes.forEach(function(qrCode) {
          if (qrCode.style.display === 'block') {
              qrCode.style.display = 'none';
          }
        });
    });
    });


   var Esim = document.querySelector("#Esim-id");
   var windowUrl =  window.location.href;

if (windowUrl.includes("#myesim")) {
    var csesimTab = document.getElementById("csesimTab");
     console.log("Loaded");
    if (csesimTab) {
      console.log("My tab");
        csesimTab.click();
    }
}
   Esim.addEventListener("click",function(){
     if (windowUrl.includes("#myesim")) {
    var csesimTab = document.getElementById("csesimTab");
     console.log("Loaded");
    if (csesimTab) {
      console.log("My tab");
        csesimTab.click();
    }
}
   });
  
   //  Esim.addEventListener("click",function(){
   //    var localEsim = localStorage.setItem("myEsim","Esim Tab");
   //  var allBtns = document.querySelector(".tab-buttons");
   //    console.log(allBtns);
   //  var insideBtns = allBtns.querySelectorAll(".tab-button");
   //    console.log("New Esim Tab");
   //   insideBtns.forEach((singleTab, index) => {
   //    var esimContent =  document.getElementById("my-esims");
   //    var accountInfo =  document.getElementById("account-info");
   // if (windowUrl.includes("#myesim")) {
   //          if (index === 1) {
   //              singleTab.classList.add("active");
   //          } else {
   //              singleTab.classList.remove("active");
   //          }
   //     accountInfo.classList.remove("active-tab");
   //     esimContent.classList.add("active-tab");
   // }
   //      });
   //     });

  // console.log("This is my new JS file");
});